var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 7.14369C26 9.11614 21.5228 10.7151 16 10.7151C10.4772 10.7151 6 9.11614 6 7.14369M26 7.14369C26 5.17125 21.5228 3.57227 16 3.57227C10.4772 3.57227 6 5.17125 6 7.14369M26 7.14369V24.2866C26 26.259 21.5228 27.858 16 27.858C10.4772 27.858 6 26.259 6 24.2866V7.14369M26 12.858C26 14.8304 21.5228 16.4294 16 16.4294C10.4772 16.4294 6 14.8304 6 12.858M26 18.5723C26 20.5447 21.5228 22.1437 16 22.1437C10.4772 22.1437 6 20.5447 6 18.5723",
    stroke: "#C5CCD3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrrIcon);
export default __webpack_public_path__ + "static/media/drr_icon.89fadeeb0545a91f9d0df08e3d0f8357.svg";
export { ForwardRef as ReactComponent };